export default __webpack_public_path__ + "static/media/Asset 11.5c6f0edf.png";